import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';
import { useT } from '../../i18n';
import './ComingSoon.css';

const ComingSoon = () => {
  const t = useT();

  return (
    <div className="coming-soon">
      <div className="coming-soon__glow" aria-hidden="true" />
      <div className="coming-soon__blocks" aria-hidden="true" />

      <div className="coming-soon__lang">
        <LanguageSwitcher variant="standalone" />
      </div>

      <main className="coming-soon__content">
        <p className="coming-soon__kicker">{t('comingSoon.kicker')}</p>
        <h1 className="coming-soon__brand">{t('common.brand')}</h1>
        <p className="coming-soon__title">{t('comingSoon.title')}</p>
        <p className="coming-soon__lead">{t('comingSoon.lead')}</p>

        <a
          href="https://discord.gg/9W4Vusc4m2"
          target="_blank"
          rel="noopener noreferrer"
          className="coming-soon__btn"
        >
          <FaDiscord />
          {t('comingSoon.joinDiscord')}
        </a>

        <Link to="/admin" className="coming-soon__staff">
          {t('comingSoon.staffAccess')}
        </Link>

        <p className="coming-soon__footer">{t('common.copyright')}</p>
      </main>
    </div>
  );
};

export default ComingSoon;
